import { combine } from 'effector';
import { createDeleteDeviceDetailedModel } from 'features/delete-device';
import { createEditDeviceDetailedModel } from 'features/edit-device';
import { accountTreeModel } from 'entities/account';
import { createDeviceRegistryModel } from 'entities/device';
import { accountPageModel } from './account-page-model';

const editDeviceModel = createEditDeviceDetailedModel();

const deleteDeviceModel = createDeleteDeviceDetailedModel();

const $cashdeskAccountIds = combine(
	accountPageModel.$accountId,
	accountTreeModel.$nodes,
	(accountId, nodes) => {
		if (accountId === null) return [];

		const accountIds = Object.values(nodes)
			.filter((node) => node.value.parents.split('.').includes(String(accountId)))
			.map((node) => node.id);

		return accountIds.length > 0 ? accountIds : [accountId];
	},
);

const deviceRegistryModel = createDeviceRegistryModel({
	$accountId: accountPageModel.$accountId,
	$allAccountIds: $cashdeskAccountIds,
	$currencies: accountTreeModel.$currencies,
	onDelete: [deleteDeviceModel.mutation.finished.success],
	onUpdate: [
		accountPageModel.accountIdSet,
		editDeviceModel.editDeviceDetailedMutation.finished.success,
	],
});

export const accountPageDevicesModel = {
	editDeviceModel,
	deleteDeviceModel,
	deviceRegistryModel,
};
